import { motion } from "framer-motion";

import hero1 from './image/introduce/hero1.png';
import hero2 from './image/introduce/hero2.png';
import hero3 from './image/introduce/hero3.png';
import hero4 from './image/introduce/hero4.png';

const heroImages = [hero1, hero2, hero3, hero4];

export default function HeroGallery() {
  return (
    <div 
      className="relative flex justify-center items-center gap-2 overflow-hidden px-2 py-10 min-h-[400px] md:min-h-[600px]"
      style={{ perspective: "1200px" }} // Tạo chiều sâu cho hiệu ứng lật 3D
    >
      {heroImages.map((src, index) => (
        <motion.div
          key={index}
          className="w-1/4 h-[350px] md:h-[550px]" // Cố định chiều cao đồng bộ
          initial={{ opacity: 0, rotateY: 180, scale: 0.8 }}
          animate={{
            opacity: 1,
            rotateY: 0,
            scale: 1,
          }}
          transition={{
            duration: 1.5,
            delay: index * 0.3,
            type: "spring",
            stiffness: 100,
            damping: 15
          }}
        >
          <motion.img
            src={src}
            alt={`hero-${index}`}
            className="w-full h-full object-cover rounded-2xl shadow-2xl border-2 border-white/50"
            whileHover={{ 
              scale: 1.05, 
              zIndex: 10,
              rotateZ: index % 2 === 0 ? 2 : -2 
            }}
            transition={{ duration: 0.3 }}
          />
        </motion.div>
      ))}

      {/* Dòng chữ: Hiệu ứng hiện ra sau khi dàn ảnh xong */}
      <motion.div
        className="absolute inset-0 flex items-center justify-center pointer-events-none"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          delay: 1.5, // Xuất hiện sau khi các tấm ảnh đã lật xong
          duration: 1,
          ease: "easeOut",
        }}
      >
        <div className="bg-black/30 backdrop-blur-md px-10 py-6 rounded-[30px] border border-white/30 shadow-2xl mx-4">
          <h1 className="text-white font-black text-4xl md:text-7xl tracking-tighter text-center uppercase leading-none drop-shadow-2xl">
            Đầu đội nắng lạ,<br />
            <span className="text-orange-400">Chân đạp đất xa</span>
          </h1>
          <p className="text-white/70 text-center mt-4 tracking-[0.4em] font-bold text-xs md:text-sm uppercase">
            Nơi bắt đầu cho những người mới leo
          </p>
        </div>
      </motion.div>
    </div>
  );
}